import qs from 'qs';

const priceRangeRegex = /^£[\d]+ - £[\d]+$/; // e.g. £300 - £500

export const getAriaTextIfPriceRange = (label) =>
  label && priceRangeRegex.test(label) ? label.replace('-', 'to') : undefined;

/**
 * Returns an array of products with `chunkSize` number of products.
 * The products included in the array is determined by which `chunk` it is
 * @param products
 * @param chunk
 * @param chunkSize
 * @returns {*}
 */
export const getChunkedData = (products, chunk, chunkSize, startIndex = 0) => {
  if (!products) return [];

  if (products.data) {
    return products.data.slice(startIndex, chunk * parseInt(chunkSize, 10));
  }
  return products.slice(startIndex, chunk * parseInt(chunkSize, 10));
};

export const getQueryString = ({
  sortBy,
  pageSize,
  page,
  pageNumber,
  facetId,
  price,
  priceBands,
}) => {
  const safeFacetId = facetId && facetId.replace(/®/g, '');

  const query = {
    sortBy,
    pageSize,
    page: pageNumber || page,
    facetId: safeFacetId,
    price: price || undefined,
    priceBands: priceBands || undefined,
  };

  const removeArrayDuplicates = (prefix, value) => {
    /* istanbul ignore else */
    if (Array.isArray(value)) {
      return value[0];
    }

    return value;
  };

  return qs.stringify(query, {
    encode: true,
    indices: false,
    filter: removeArrayDuplicates,
  });
};

export const isElementInView = (el) => {
  const bounding = el.getBoundingClientRect();
  return bounding.top >= 0 || bounding.bottom >= 0;
};

export const randNumBetween = (min = 0, max = 10) =>
  Math.floor(Math.random() * (max - min + 1) + min);
